import { FC } from "react";
import ActionButton from "../ActionButton.tsx";
import Container from "../Container.tsx";
import ContainerHeader from "../ContainerHeader.tsx";
import { Trans } from "@lingui/react/macro"; // Import the new component
import { format } from "date-fns";
import { useLanguageStore } from "../../stores/languageStore.ts";
import { Blocker } from "../../api/scheduleApi.ts";

interface BlockerListProps {
  blockers: Blocker[];
  onDeleteEvent: (id: string) => void;
  deletingId: string | null;
}

const BlockerList: FC<BlockerListProps> = ({
  blockers,
  onDeleteEvent,
  deletingId,
}) => {
  const handleDeleteClick = (id: string) => {
    onDeleteEvent(id);
  };
  const { dateFnsLocale } = useLanguageStore();

  return (
    <Container>
      <ContainerHeader>
        <Trans>Your Blockers</Trans>
      </ContainerHeader>
      {blockers.length === 0 ? (
        <p className="text-gray-500">
          <Trans>No blockers added yet.</Trans>
        </p>
      ) : (
        <ul className="divide-y divide-gray-200">
          {blockers.map((blocker) => {
            const formattedDate = format(blocker.from, "P", {
              locale: dateFnsLocale,
            });

            const isDeleting = deletingId === blocker.id;
            const anyDeleting = deletingId !== null;

            return (
              <li
                key={blocker.id}
                className="flex items-center justify-between py-4"
              >
                <div>
                  <p className="text-lg font-medium text-gray-900">
                    {formattedDate}
                  </p>
                  <p className="text-sm text-gray-500">
                    {format(blocker.from, "p", {
                      locale: dateFnsLocale,
                    })}{" "}
                    -{" "}
                    {format(blocker.to, "p", {
                      locale: dateFnsLocale,
                    })}
                  </p>
                  <p className="text-sm text-gray-500">{blocker.title}</p>
                </div>
                <ActionButton
                  onClick={() => handleDeleteClick(blocker.id!)}
                  disabled={anyDeleting}
                  isLoading={isDeleting}
                  className="ml-4 rounded-full px-3 py-1.5 text-xs"
                >
                  <Trans>Delete</Trans>
                </ActionButton>
              </li>
            );
          })}
        </ul>
      )}
    </Container>
  );
};

export default BlockerList;
